import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { useIsFinchOnboardingEnabledForPlatform } from '../../externalServices/finch/useFinchIframe'
import { HealthcheckStatusResult } from '../types'
import { getFinchConnections } from './finchConnectionUtils'

export const useFinchSetupStatus = (
  org: OrganizationDetailFragment | null | undefined,
  _todo?: boolean
): Pick<HealthcheckStatusResult, 'status' | 'secondary'> | null => {
  const finchConnectEnabled = useIsFinchOnboardingEnabledForPlatform(org)

  if (!org || !finchConnectEnabled) {
    return null // Component doesn't render if Finch is not enabled
  }

  const finchConnections = getFinchConnections(org)

  const isFinchConnected = finchConnections.connected.length > 0

  return {
    status: isFinchConnected ? 'complete' : 'incomplete',
    secondary: isFinchConnected
      ? 'Alice can load the employee roster and reconcile benefits'
      : 'Allow Alice access to your employee roster',
  }
}
